import React from 'react';
import { Link } from 'react-router-dom';
import i18next from "i18next";

const RowButton = ({allowView, allowEdit, allowCopy, viewClick, editClick, copyClick, viewPath, editPath, copyPath, rowId, children}) => (
        <div className="text-center">
         {allowView && (viewPath ?
                  <Link className="btn btn-sm btn-default"
                       to={viewPath}
                       >{ i18next.t('form-labels.view') }</Link>
                  :
                  <button className="btn btn-sm btn-default"
                       onClick={() => viewClick(rowId)}
                       >{ i18next.t('form-labels.view') }</button>
         )}
         &nbsp;
         {allowEdit && (editPath ?
                  <Link className="btn btn-sm btn-default"
                          to={editPath}
                          >{ i18next.t('form-labels.edit') }</Link>
                  :
                  <button className="btn btn-sm btn-default"
                          onClick={() => editClick(rowId)}
                          >{ i18next.t('form-labels.edit') }</button>
        )}
        &nbsp;
        { allowCopy && (copyPath ?
                <Link className="btn btn-sm btn-default"
                        to={copyPath}
                        >{ i18next.t('form-labels.duplicate') }</Link>
                :
                <button className="btn btn-sm btn-default"
                        onClick={() => copyClick(rowId)}
                        >{ i18next.t('form-labels.duplicate') }</button>
        )}
        { children }
        </div>
  );

export default RowButton;